module.exports = __webpack_public_path__ + "img/logo_dark.4a1c272b.svg";